import { render, staticRenderFns } from "./automobileSix.vue?vue&type=template&id=35c5bc2f&scoped=true"
import script from "./automobileSix.vue?vue&type=script&lang=js"
export * from "./automobileSix.vue?vue&type=script&lang=js"
import style0 from "./automobileSix.vue?vue&type=style&index=0&id=35c5bc2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c5bc2f",
  null
  
)

export default component.exports